export default {
  adminFeesResults: [],
};
